import { render } from "./PrintInvoice.vue?vue&type=template&id=1b9c8447&scoped=true"
import script from "./PrintInvoice.vue?vue&type=script&lang=js"
export * from "./PrintInvoice.vue?vue&type=script&lang=js"

import "./PrintInvoice.vue?vue&type=style&index=0&id=1b9c8447&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b9c8447"

export default script